import _throttle from "lodash.throttle";

const nav = document.querySelector('.c-hero__breadcrumb');

const breadcrumb = () => {

   const navWidth = nav.clientWidth;
   const lastNavElm = nav.querySelector('[property="itemListElement"]:last-of-type');
   const lastNavElmWidth = lastNavElm.clientWidth;

   const parentEl = nav.closest('.o-wrapper');
   let parentWidth = parentEl.clientWidth;

   const parentComputedStyle = getComputedStyle(parentEl);
   parentWidth -= parseFloat(parentComputedStyle.paddingLeft) + parseFloat(parentComputedStyle.paddingRight);

   const newLastElmWidth = (parentWidth - navWidth + lastNavElmWidth);
   lastNavElm.style.setProperty('--max-breadcrumb-length', `${newLastElmWidth}px`)

}

if(nav) {
  breadcrumb();
  window.addEventListener('resize', _throttle(() => breadcrumb(), 500))
}
